/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/explorable-exercise/v2.ts
 */
import { createValidator } from '../../helpers/validator';
export var ExplorableExerciseV2Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          pre_exercise_code: {
            type: 'string',
            default: ''
          },
          flavor: {
            type: 'string',
            enum: ['Open'],
            default: 'Open'
          },
          openQuestions: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                question: {
                  type: 'string',
                  description: 'Question asked to the user.'
                },
                solution: {
                  type: 'object',
                  properties: {
                    answer: {
                      type: 'string',
                      description: 'Correct answer to the question.'
                    },
                    message: {
                      type: 'string',
                      description: 'Feedback message when the submission matches the pattern.'
                    },
                    pattern: {
                      type: 'string',
                      description: 'Regex that should validate the correctness of the submission.'
                    }
                  },
                  required: ['answer', 'message', 'pattern']
                },
                feedback: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      message: {
                        type: 'string',
                        description: 'Feedback message when the submission matches the pattern.'
                      },
                      pattern: {
                        type: 'string',
                        description: 'If the regex matches, the feedback message will be shown. The last pattern should be ".*" to show a default error message.'
                      }
                    },
                    required: ['message', 'pattern']
                  },
                  description: 'List of feedback displayed when the submission is incorrect.'
                }
              },
              required: ['question', 'solution', 'feedback']
            },
            description: 'List of open questions.'
          }
        },
        required: ['flavor', 'openQuestions', 'pre_exercise_code'],
        title: 'Open'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['MultipleChoice'],
            default: 'MultipleChoice'
          },
          possible_answers: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          pre_exercise_code: {
            type: 'string',
            default: ''
          },
          question: {
            type: 'string',
            default: ''
          },
          sct: {
            type: 'string',
            default: ''
          }
        },
        required: ['flavor', 'possible_answers', 'pre_exercise_code', 'sct'],
        title: 'MultipleChoiceQuestion'
      }]
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'language', 'question', 'title', 'xp'],
  definitions: {}
};
export var isValidExplorableExerciseV2 = createValidator(ExplorableExerciseV2Schema);
export var ExplorableExerciseV2Definition = {
  schema: ExplorableExerciseV2Schema,
  validate: isValidExplorableExerciseV2
};